export default __webpack_public_path__ + "static/media/people.1757ca0a.svg";